import Storefront from "../../Pages/Storefront/Storefront.Page";

export default function StorefrontRoute() {
    return (
        <Storefront />
    );
}
